import { render, staticRenderFns } from "./importphotos.component.html?vue&type=template&id=d73f473e&scoped=true&"
import script from "./importphotos.component.ts?vue&type=script&lang=ts&"
export * from "./importphotos.component.ts?vue&type=script&lang=ts&"
import style0 from "./importphotos.component.scss?vue&type=style&index=0&id=d73f473e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73f473e",
  null
  
)

export default component.exports